export default "partners";
